import { isAccordionItemProps, isBaseItemProps, isGroupItemProps, isNextListItemProps, } from '@snack-uikit/list';
export function withCollapsedItems({ items, openCollapsedItems }) {
    let itemRefs = [];
    let newItems = [];
    let ids = [];
    let expandedIds = [];
    items.forEach(item => {
        var _a;
        if (((isBaseItemProps(item) && !item.inactive) || isNextListItemProps(item) || isAccordionItemProps(item)) &&
            !item.disabled) {
            newItems = newItems.concat([item]);
            ids = ids.concat([(_a = item.id) !== null && _a !== void 0 ? _a : '']);
            if (item.itemRef) {
                itemRefs = itemRefs.concat([item.itemRef]);
            }
        }
        if (isNextListItemProps(item) && item.id && !item.disabled) {
            expandedIds = expandedIds.concat(item.id);
        }
        if (isGroupItemProps(item)) {
            const { itemRefs: nestedItemsRefs, ids: nestedIds } = withCollapsedItems({
                items: item.items,
                openCollapsedItems,
            });
            ids = ids.concat(nestedIds);
            itemRefs = itemRefs.concat(nestedItemsRefs);
        }
        if (isAccordionItemProps(item) && item.id && openCollapsedItems.includes(item.id)) {
            const { itemRefs: nestedItemsRefs, ids: nestedIds, items: nestedItems, expandedIds: nestedExpandedIds, } = withCollapsedItems({
                items: item.items,
                openCollapsedItems,
            });
            ids = ids.concat(nestedIds);
            newItems = newItems.concat(nestedItems);
            itemRefs = itemRefs.concat(nestedItemsRefs);
            expandedIds = expandedIds.concat(nestedExpandedIds);
        }
    });
    return { items, itemRefs, ids, expandedIds };
}
/**
 * Функция возвращает массив id дочерних items
 * @function  extractItemIds
 */
export function extractItemIds(items) {
    return items.reduce((prev, item) => {
        if (isGroupItemProps(item)) {
            return prev.concat(extractItemIds(item.items));
        }
        return item.id ? prev.concat([item.id]) : prev;
    }, []);
}
export function extractChildIds({ items }) {
    return items
        .filter(item => isAccordionItemProps(item) ||
        isNextListItemProps(item) ||
        isGroupItemProps(item) ||
        (isBaseItemProps(item) && !item.disabled && !item.inactive))
        .reduce((prev, item) => {
        var _a;
        if (isAccordionItemProps(item) || isNextListItemProps(item)) {
            return prev.concat([(_a = item.id) !== null && _a !== void 0 ? _a : '']).concat(extractChildIds({ items: item.items }));
        }
        if (isGroupItemProps(item)) {
            return prev.concat(extractChildIds({ items: item.items }));
        }
        return item.id && !isGroupItemProps(item) ? prev.concat([item.id]) : prev;
    }, []);
}
export function extractAllChildIds({ items }) {
    return items
        .filter(item => isAccordionItemProps(item) ||
        isNextListItemProps(item) ||
        isGroupItemProps(item) ||
        (isBaseItemProps(item) && !item.inactive))
        .reduce((prev, item) => {
        var _a;
        if (isAccordionItemProps(item) || isNextListItemProps(item)) {
            return prev.concat([(_a = item.id) !== null && _a !== void 0 ? _a : '']).concat(extractAllChildIds({ items: item.items }));
        }
        if (isGroupItemProps(item)) {
            return prev.concat(extractAllChildIds({ items: item.items }));
        }
        return item.id && !isGroupItemProps(item) ? prev.concat([item.id]) : prev;
    }, []);
}
/**
 * Функция разворачивает массив айтемов в плоский список
 *  @function  flattenItems
 */
export function flattenItems(items) {
    const flattenItems = [];
    function flatten(item) {
        if (!isGroupItemProps(item)) {
            flattenItems.push(item);
        }
        if ('items' in item) {
            for (const nestedItem of item.items) {
                flatten(nestedItem);
            }
        }
    }
    for (const item of items) {
        flatten(item);
    }
    return flattenItems;
}
